export class LottoGame {
  drwNo = 0;
  drwtNo1 = 0;
  drwtNo2 = 0;
  drwtNo3 = 0;
  drwtNo4 = 0;
  drwtNo5 = 0;
  drwtNo6 = 0;
  buyType = "TERRA"; // TERRA/AUTO/MANUAL/SEMI_AUTO

  init(
    drwNo: number,
    drwtNo1: number,
    drwtNo2: number,
    drwtNo3: number,
    drwtNo4: number,
    drwtNo5: number,
    drwtNo6: number
  ) {
    this.drwNo = drwNo;
    this.drwtNo1 = drwtNo1;
    this.drwtNo2 = drwtNo2;
    this.drwtNo3 = drwtNo3;
    this.drwtNo4 = drwtNo4;
    this.drwtNo5 = drwtNo5;
    this.drwtNo6 = drwtNo6;
  }

  bind(data: LottoGame) {
    this.drwNo = data.drwNo;
    this.drwtNo1 = data.drwtNo1;
    this.drwtNo2 = data.drwtNo2;
    this.drwtNo3 = data.drwtNo3;
    this.drwtNo4 = data.drwtNo4;
    this.drwtNo5 = data.drwtNo5;
    this.drwtNo6 = data.drwtNo6;
    this.buyType = data.buyType ?? "TERRA";
  }

  fromLottoGameBuyResponse(data: LottoGameBuyResponse) {
    this.drwNo = data.drwNo;
    this.drwtNo1 = data.drwtNo1;
    this.drwtNo2 = data.drwtNo2;
    this.drwtNo3 = data.drwtNo3;
    this.drwtNo4 = data.drwtNo4;
    this.drwtNo5 = data.drwtNo5;
    this.drwtNo6 = data.drwtNo6;
    this.buyType = data.buyType ?? "TERRA";
    return this;
  }
}

export class LottoGameBuySummaryResponse {
  drwNo = 0;
  drwNoDate = "";
  progressList: LottoGameBuyResponse[] = [];
  resultList: LottoResultAndGameBuy[] = [];

  public bind(res: any) {
    console.log("summaray bind : ", res);
    console.log("drwNo : ", res.data.drwNo);
    this.drwNo = res.data.drwNo ?? 0;
    this.drwNoDate = res.data.drwNoDate;

    this.progressList = res.data.progressList
      ? res.data.progressList.map((progress: any) => {
          const item = new LottoGameBuyResponse();
          item.init(progress);
          return item;
        })
      : [];

    this.resultList = res.data.resultList
      ? res.data.resultList.map((result: any) => {
          const item = new LottoResultAndGameBuy();
          item.init(result);
          return item;
        })
      : [];
  }
}

export class LottoGameBuyResponse {
  id = 0;
  drwNo = 0;
  drwNoDate = "";
  drwtNo1 = 0;
  drwtNo2 = 0;
  drwtNo3 = 0;
  drwtNo4 = 0;
  drwtNo5 = 0;
  drwtNo6 = 0;
  winDrwtNo1 = 0;
  winDrwtNo2 = 0;
  winDrwtNo3 = 0;
  winDrwtNo4 = 0;
  winDrwtNo5 = 0;
  winDrwtNo6 = 0;
  rank = 0;
  prize = 0;
  nickname = "";
  createDatetime = "";
  buyType = "TERRA"; // TERRA/AUTO/MANUAL/SEMI_AUTO

  public init(obj: any) {
    this.id = obj.id ?? 0;
    this.drwNo = obj.drwNo ?? 0;
    this.drwNoDate = obj.drwNoDate ?? "";
    this.drwtNo1 = obj.drwtNo1 ?? 0;
    this.drwtNo2 = obj.drwtNo2 ?? 0;
    this.drwtNo3 = obj.drwtNo3 ?? 0;
    this.drwtNo4 = obj.drwtNo4 ?? 0;
    this.drwtNo5 = obj.drwtNo5 ?? 0;
    this.drwtNo6 = obj.drwtNo6 ?? 0;
    this.winDrwtNo1 = obj.winDrwtNo1 ?? 0;
    this.winDrwtNo2 = obj.winDrwtNo2 ?? 0;
    this.winDrwtNo3 = obj.winDrwtNo3 ?? 0;
    this.winDrwtNo4 = obj.winDrwtNo4 ?? 0;
    this.winDrwtNo5 = obj.winDrwtNo5 ?? 0;
    this.winDrwtNo6 = obj.winDrwtNo6 ?? 0;
    this.rank = obj.rank ?? 0;
    this.prize = obj.prize ?? 0;
    this.nickname = obj.nickname ?? "";
    this.createDatetime = obj.createDatetime;
    this.buyType = obj.buyType ?? "TERRA";
  }

  public bind(res: any) {
    this.id = res.data.id ?? 0;
    this.drwNo = res.data.drwNo ?? 0;
    this.drwNoDate = res.data.drwNoDate ?? "";
    this.drwtNo1 = res.data.drwtNo1 ?? 0;
    this.drwtNo2 = res.data.drwtNo2 ?? 0;
    this.drwtNo3 = res.data.drwtNo3 ?? 0;
    this.drwtNo4 = res.data.drwtNo4 ?? 0;
    this.drwtNo5 = res.data.drwtNo5 ?? 0;
    this.drwtNo6 = res.data.drwtNo6 ?? 0;
    this.winDrwtNo1 = res.data.winDrwtNo1 ?? 0;
    this.winDrwtNo2 = res.data.winDrwtNo2 ?? 0;
    this.winDrwtNo3 = res.data.winDrwtNo3 ?? 0;
    this.winDrwtNo4 = res.data.winDrwtNo4 ?? 0;
    this.winDrwtNo5 = res.data.winDrwtNo5 ?? 0;
    this.winDrwtNo6 = res.data.winDrwtNo6 ?? 0;
    this.rank = res.data.rank ?? 0;
    this.prize = res.data.prize ?? 0;
    this.nickname = res.data.nickname ?? "";
    this.createDatetime = res.data.createDatetime;
    this.buyType = res.data.buyType ?? "TERRA";
  }

  public isDraw(): boolean {
    return this.rank > 0;
  }
}

export class LottoResultPrize {
  rank = 0;
  winCount = 0;
  winAmount = 0;
  totalAmount = 0;
}

export class LottoResultResponse {
  drwNo = 0;
  drwNoDate = "";

  totSellamnt = 0;
  firstWinamnt = 0;
  firstPrzwnerCo = 0;
  firstAccumamnt = 0;

  drwtNo1 = 0;
  drwtNo2 = 0;
  drwtNo3 = 0;
  drwtNo4 = 0;
  drwtNo5 = 0;
  drwtNo6 = 0;
  bnusNo = 0;
  returnValue = false;
  winType0 = 0;
  winType1 = 0;
  winType2 = 0;
  winType3 = 0;
  prizes: LottoResultPrize[] = [];

  public init(obj: any) {
    console.log("obj : ", obj);
    this.drwNo = obj.drwNo ?? 0;
    this.drwNoDate = obj.drwNoDate ?? "";
    this.totSellamnt = obj.totSellamnt ?? 0;
    this.firstWinamnt = obj.firstWinamnt ?? 0;
    this.firstPrzwnerCo = obj.firstPrzwnerCo ?? 0;
    this.firstAccumamnt = obj.firstAccumamnt ?? 0;
    this.drwtNo1 = obj.drwtNo1 ?? 0;
    this.drwtNo2 = obj.drwtNo2 ?? 0;
    this.drwtNo3 = obj.drwtNo3 ?? 0;
    this.drwtNo4 = obj.drwtNo4 ?? 0;
    this.drwtNo5 = obj.drwtNo5 ?? 0;
    this.drwtNo6 = obj.drwtNo6 ?? 0;
    this.bnusNo = obj.bnusNo ?? 0;
    this.returnValue = obj.returnValue ?? false;
    this.winType0 = obj.winType0 ?? 0;
    this.winType1 = obj.winType1 ?? 0;
    this.winType2 = obj.winType2 ?? 0;
    this.winType3 = obj.winType3 ?? 0;
    this.prizes = (obj.prizes ?? []).map((p: any) => {
      const prize = new LottoResultPrize();
      prize.rank = p.rank ?? 0;
      prize.winCount = p.winCount ?? 0;
      prize.winAmount = p.winAmount ?? 0;
      prize.totalAmount = p.totalAmount ?? 0;
      return prize;
    });
  }

  public bind(res: any) {
    this.drwNo = res.data.drwNo ?? 0;
    this.drwNoDate = res.data.drwNoDate ?? "";
    this.totSellamnt = res.data.totSellamnt ?? 0;
    this.firstWinamnt = res.data.firstWinamnt ?? 0;
    this.firstPrzwnerCo = res.data.firstPrzwnerCo ?? 0;
    this.firstAccumamnt = res.data.firstAccumamnt ?? 0;
    this.drwtNo1 = res.data.drwtNo1 ?? 0;
    this.drwtNo2 = res.data.drwtNo2 ?? 0;
    this.drwtNo3 = res.data.drwtNo3 ?? 0;
    this.drwtNo4 = res.data.drwtNo4 ?? 0;
    this.drwtNo5 = res.data.drwtNo5 ?? 0;
    this.drwtNo6 = res.data.drwtNo6 ?? 0;
    this.bnusNo = res.data.bnusNo ?? 0;
    this.returnValue = res.data.returnValue ?? false;
    this.winType0 = res.data.winType0 ?? 0;
    this.winType1 = res.data.winType1 ?? 0;
    this.winType2 = res.data.winType2 ?? 0;
    this.winType3 = res.data.winType3 ?? 0;
    this.prizes = (res.data.prizes ?? []).map((p: any) => {
      const prize = new LottoResultPrize();
      prize.rank = p.rank ?? 0;
      prize.winCount = p.winCount ?? 0;
      prize.winAmount = p.winAmount ?? 0;
      prize.totalAmount = p.totalAmount ?? 0;
      return prize;
    });
  }
}

export class LottoNumberCount {
  number = 0;
  count = 0;
  bonusCount = 0;
}

export class LottoNumberCountResponse {
  numberCountList: LottoNumberCount[] = [];

  public bind(res: any) {
    this.numberCountList = res.data
      ? res.data.map((item: any) => {
          const nc = new LottoNumberCount();
          nc.number = item.drwtNo ?? 0;
          nc.count = item.showCount ?? 0;
          nc.bonusCount = item.bonusCount ?? 0;
          return nc;
        })
      : [];
  }
}

export class LottoAccompanyCount {
  drwtNo1 = 0;
  drwtNo2 = 0;
  showCount = 0;
}

export class LottoAccompanyCountResponse {
  accompanyList: LottoAccompanyCount[] = [];

  public bind(res: any) {
    this.accompanyList = res.data
      ? res.data.map((item: any) => {
          const ac = new LottoAccompanyCount();
          ac.drwtNo1 = item.drwtNo1 ?? 0;
          ac.drwtNo2 = item.drwtNo2 ?? 0;
          ac.showCount = item.showCount ?? 0;
          return ac;
        })
      : [];
  }
}

export class LottoFavorite {
  id = 0;
  favoriteName = "";
  drwtNo1 = 0;
  drwtNo2 = 0;
  drwtNo3 = 0;
  drwtNo4 = 0;
  drwtNo5 = 0;
  drwtNo6 = 0;
  createDatetime = "";

  public init(obj: any) {
    this.id = obj.id ?? 0;
    this.favoriteName = obj.favoriteName ?? "";
    this.drwtNo1 = obj.drwtNo1 ?? 0;
    this.drwtNo2 = obj.drwtNo2 ?? 0;
    this.drwtNo3 = obj.drwtNo3 ?? 0;
    this.drwtNo4 = obj.drwtNo4 ?? 0;
    this.drwtNo5 = obj.drwtNo5 ?? 0;
    this.drwtNo6 = obj.drwtNo6 ?? 0;
    this.createDatetime = obj.createDatetime ?? "";
  }

  public getNumbers(): number[] {
    return [this.drwtNo1, this.drwtNo2, this.drwtNo3, this.drwtNo4, this.drwtNo5, this.drwtNo6];
  }
}

export class LottoResultAndGameBuy {
  result: LottoResultResponse = new LottoResultResponse();
  gameBuyList: LottoGameBuyResponse[] = [];

  public init(obj: any) {
    if (obj.result) {
      this.result.bind({ data: obj.result });
    }

    this.gameBuyList = obj.gameBuyList
      ? obj.gameBuyList.map((gameData: any) => {
          const game = new LottoGameBuyResponse();
          game.bind({ data: gameData });
          return game;
        })
      : [];
  }

  public bind(res: any) {
    if (res.data.result) {
      this.result.bind({ data: res.data.result });
    }

    this.gameBuyList = res.data.gameBuyList
      ? res.data.gameBuyList.map((gameData: any) => {
          const game = new LottoGameBuyResponse();
          game.bind({ data: gameData });
          return game;
        })
      : [];
  }
}
